module.exports = __webpack_public_path__ + "static/media/cap1-03-desk.07439191.png";